import React, { useState, useEffect } from "react";
import {
  ThinTextField,
  ThinDropdownWithSearch,
} from "../common/GeneralComponent";
import { fetchData } from "../../utils/functions";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import Select from "react-select";

const WashSanitation = ({
  washSanitation: propWashSanitation,
  onChange,
  washInformationId,
  onUpdate,
}) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [washSanitationData, setWashSanitationData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [updating, setUpdating] = useState(false);
  const [currentWashInfoId, setCurrentWashInfoId] = useState(null);
  const [washSanitationId, setWashSanitationId] = useState(null);
  const [isDqaApproved, setIsDqaApproved] = useState(false);
  const [isDqaRejected, setIsDqaRejected] = useState(false);
  const [washInfoData, setWashInfoData] = useState(null);
  const [errors, setErrors] = useState({});

  const [formData, setFormData] = useState({
    number_of_household_served: "",
    number: "",
    type_of_toilet: "",
    status_of_toilet: "",
    non_functional_since: "",
    ownership: "",
    year_of_construction: "",
    accessibility: "",
    cultural_gender: "",
    has_pit_latrines: "",
    last_time_emptied: "",
    where_was_it_disposed: "",
    where_was_it_taken: "",
    last_time_emptied_other: "",
    emptied_by_household_disposal: "",
    removed_by_service_provider: "",
    removed_by_service_provider_disposal: "",
    removed_by_service_provider_other: "",
    emptied_by_household: "",
    affected_by_floods: "",
    functional_handwashing: "",
    soap_detergent_available: "",
    hygiene_promotion: "",
    hygiene_promotion_specify: "",
    hygiene_promotion_other: "",
    disposal_of_latrine_waste: "",
    septic_tanks: "",
    longitude: "",
    latitude: "",
  });

  // helpers
  const thisYear = new Date().getFullYear();
  const isEmpty = (v) =>
    v === null || v === undefined || String(v).trim() === "";
  const isPosInt = (v) => Number.isInteger(Number(v)) && Number(v) > 0;
  const isNonNegInt = (v) => Number.isInteger(Number(v)) && Number(v) >= 0;
  const isNumber = (v) => v !== "" && !isNaN(Number(v));
  const isGreaterThanOrEqual = (v, n) => Number(v) >= n;
  const isLessThanOrEqual = (v, n) => Number(v) <= n;
  const isBetween = (v, a, b) =>
    isNumber(v) && isGreaterThanOrEqual(v, a) && isLessThanOrEqual(v, b);
  const currentYear = new Date().getFullYear();

  const getCurrentWashInfoId = () => washInformationId || id;

  const fetchWashInformationDetails = async (washInfoId) => {
    if (!washInfoId) return;
    try {
      const response = await fetchData(
        `wash-information/${washInfoId}`,
        "GET",
        null,
        {},
        {},
        navigate,
        "/wash",
        dispatch
      );
      if (response?.data) {
        setWashInfoData(response.data);
        setIsDqaApproved(
          response.data.verified_from_dqa === 1 ||
            response.data.verified_from_dqa === "1"
        );
        setIsDqaRejected(
          response.data.verified_from_dqa === 2 ||
            response.data.verified_from_dqa === "2"
        );
      }
    } catch (error) {
      console.error("Error fetching wash information details:", error);
    }
  };

  const resetForm = () => {
    setFormData({
      number_of_household_served: "",
      number: "",
      type_of_toilet: "",
      status_of_toilet: "",
      non_functional_since: "",
      ownership: "",
      year_of_construction: "",
      accessibility: "",
      cultural_gender: "",
      has_pit_latrines: "",
      last_time_emptied: "",
      last_time_emptied_other: "",
      emptied_by_household_disposal: "",
      removed_by_service_provider: "",
      removed_by_service_provider_disposal: "",
      removed_by_service_provider_other: "",
      emptied_by_household: "",
      where_was_it_disposed: "",
      where_was_it_taken: "",
      affected_by_floods: "",
      functional_handwashing: "",
      soap_detergent_available: "",
      hygiene_promotion: "",
      hygiene_promotion_specify: "",
      hygiene_promotion_other: "",
      disposal_of_latrine_waste: "",
      septic_tanks: "",
      longitude: "",
      latitude: "",
    });
    setWashSanitationId(null);
    setErrors({});
  };

  const parseLastTimeEmptied = (data) => {
    if (!data) return {};

    try {
      if (typeof data === "object") return data;
      const parsed = JSON.parse(data);
      return parsed;
    } catch (e) {
      return { method: data };
    }
  };

  const populateForm = (record) => {
    const lastTimeEmptiedData = parseLastTimeEmptied(record.last_time_emptied);

    let septicTanksValue = "";
    if (record.septic_tanks) {
      if (Array.isArray(record.septic_tanks)) {
        septicTanksValue = record.septic_tanks[0] || "";
      } else if (typeof record.septic_tanks === "string") {
        try {
          const parsed = JSON.parse(record.septic_tanks);
          septicTanksValue = Array.isArray(parsed)
            ? parsed[0] || ""
            : record.septic_tanks;
        } catch {
          septicTanksValue = record.septic_tanks;
        }
      }
    }

    // Helper function to normalize string values (trim whitespace and normalize apostrophes)
    const normalizeValue = (str) => {
      if (!str) return str;
      return str.trim().replace(/[\u2018\u2019\u201A\u201B\u2032\u2035]/g, "'");
    };

    // Get the last_time_emptied value
    let lastTimeEmptiedValue =
      lastTimeEmptiedData.method || record.last_time_emptied || "";

    // Normalize the value
    lastTimeEmptiedValue = normalizeValue(lastTimeEmptiedValue);

    // Only convert "Other (Specify)" to "Others"
    if (lastTimeEmptiedValue === "Other (Specify)") {
      lastTimeEmptiedValue = "Others";
    }

    // Get the removed_by_service_provider value
    let removedByServiceProvider = record.removed_by_service_provider || "";

    // If last_time_emptied was a JSON object with service_provider field, use that
    if (lastTimeEmptiedData.service_provider) {
      removedByServiceProvider = lastTimeEmptiedData.service_provider;
    }

    // Normalize the value
    removedByServiceProvider = normalizeValue(removedByServiceProvider);

    // Handle the service provider field conversions
    if (removedByServiceProvider === "Removed by service provider") {
      removedByServiceProvider = "Removed by a service provider";
    } else if (removedByServiceProvider === "Other (Specify)") {
      removedByServiceProvider = "Others";
    }

    setWashSanitationId(record.wash_sanitation_id || null);
    setFormData({
      number_of_household_served: record.number_of_household_served || "",
      number: record.number || "",
      type_of_toilet: record.type_of_toilet || "",
      status_of_toilet: record.status_of_toilet || "",
      non_functional_since: record.non_functional_since || "",
      ownership: record.ownership || "",
      year_of_construction: record.year_of_construction || "",
      accessibility: record.accessibility || "",
      cultural_gender: record.cultural_gender || "",
      has_pit_latrines: record.has_pit_latrines || "",
      last_time_emptied: lastTimeEmptiedValue,
      last_time_emptied_other:
        lastTimeEmptiedData.specify || record.last_time_emptied_other || "",
      where_was_it_disposed:
        lastTimeEmptiedData.household_disposal ||
        record.where_was_it_disposed ||
        "",
      where_was_it_taken:
        lastTimeEmptiedData.service_provider_disposal ||
        record.where_was_it_taken ||
        "",
      removed_by_service_provider: removedByServiceProvider,
      removed_by_service_provider_disposal:
        lastTimeEmptiedData.service_provider_disposal || "",
      removed_by_service_provider_other:
        lastTimeEmptiedData.service_provider_other ||
        record.removed_by_service_provider_other ||
        "",
      emptied_by_household: record.emptied_by_household || "",
      affected_by_floods: record.affected_by_floods || "",
      functional_handwashing: record.functional_handwashing || "",
      soap_detergent_available: record.soap_detergent_available || "",
      hygiene_promotion: record.hygiene_promotion || "",
      hygiene_promotion_specify: record.hygiene_promotion_specify || "",
      hygiene_promotion_other: record.hygiene_promotion_other || "",
      disposal_of_latrine_waste: record.disposal_of_latrine_waste || "",
      septic_tanks: septicTanksValue,
      longitude: record.longitude || "",
      latitude: record.latitude || "",
    });
    setErrors({});
  };

  const fetchWashSanitationData = async () => {
    const washInfoId = getCurrentWashInfoId();
    if (!washInfoId) {
      setLoading(false);
      return;
    }

    try {
      setLoading(true);

      await fetchWashInformationDetails(washInfoId);

      const response = await fetchData(
        "wash-sanitation",
        "GET",
        null,
        { wash_information_id: washInfoId },
        {},
        navigate,
        "/wash",
        dispatch
      );

      const sanitationData = response?.data?.wash_sanitation || [];
      setWashSanitationData(sanitationData);

      const filteredData = sanitationData.filter(
        (item) => item.wash_information_id == washInfoId
      );
      if (filteredData.length > 0) {
        populateForm(filteredData[0]);
      } else {
        resetForm();
      }
    } catch (error) {
      console.error("Error fetching wash sanitation data:", error);
      resetForm();
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const newWashInfoId = getCurrentWashInfoId();
    if (newWashInfoId && String(newWashInfoId) !== String(currentWashInfoId)) {
      setCurrentWashInfoId(newWashInfoId);
      fetchWashSanitationData();
    }
  }, [washInformationId, id]);

  useEffect(() => {
    if (propWashSanitation && !loading) {
      const washInfoId = getCurrentWashInfoId();

      if (Array.isArray(propWashSanitation)) {
        const matchingRecord = propWashSanitation.find(
          (item) => String(item.wash_information_id) === String(washInfoId)
        );
        if (matchingRecord) {
          populateForm(matchingRecord);
        } else {
          if (propWashSanitation.length > 0) {
            populateForm(propWashSanitation[0]);
          } else {
            resetForm();
          }
        }
      } else {
        populateForm(propWashSanitation);
      }
    }
  }, [propWashSanitation, loading, currentWashInfoId]);

  const handleFieldChange = (fieldName, value) => {
    let updatedData;

    updatedData = {
      ...formData,
      [fieldName]: value,
    };

    if (fieldName === "last_time_emptied") {
      updatedData.last_time_emptied_other = "";
      updatedData.where_was_it_disposed = "";
      updatedData.removed_by_service_provider = "";
      updatedData.removed_by_service_provider_disposal = "";
      updatedData.removed_by_service_provider_other = "";
    }

    if (fieldName === "removed_by_service_provider") {
      updatedData.removed_by_service_provider_disposal = "";
      // Only clear if NOT selecting "Others"
      if (value !== "Others") {
        updatedData.removed_by_service_provider_other = "";
      }
    }

    setFormData(updatedData);

    setErrors((prev) => {
      const next = { ...prev };
      delete next[fieldName];

      // Clear dependent field errors
      if (fieldName === "last_time_emptied") {
        delete next.last_time_emptied_other;
        delete next.emptied_by_household_disposal;
        delete next.removed_by_service_provider;
        delete next.removed_by_service_provider_disposal;
        delete next.removed_by_service_provider_other;
      }

      if (fieldName === "removed_by_service_provider") {
        delete next.removed_by_service_provider_disposal;
        // Only clear if NOT selecting "Others"
        if (value !== "Others") {
          delete next.removed_by_service_provider_other;
        }
      }

      return next;
    });

    if (onChange) {
      onChange(updatedData);
    }
  };

  // ---------------- VALIDATION ----------------
  const validate = () => {
    const e = {};

    if (isEmpty(formData.number_of_household_served)) {
      e.number_of_household_served = "Number of households served is required.";
    } else if (
      !isNumber(formData.number_of_household_served) ||
      !isGreaterThanOrEqual(formData.number_of_household_served, 1)
    ) {
      e.number_of_household_served = "Enter a valid number greater than 0.";
    }

    if (isEmpty(formData.type_of_toilet)) {
      e.type_of_toilet = "Type of toilet is required.";
    }

    if (isEmpty(formData.status_of_toilet)) {
      e.status_of_toilet = "Status of toilet is required.";
    }

    // Non-functional since (only when non-functional)
    if (formData.status_of_toilet === "Non-functional") {
      if (isEmpty(formData.non_functional_since)) {
        e.non_functional_since = "Please enter days since non-functional.";
      } else if (!isPosInt(formData.non_functional_since)) {
        e.non_functional_since = "Enter a whole number greater than 0.";
      }
    }

    // Ownership
    if (isEmpty(formData.ownership)) {
      e.ownership = "Ownership is required.";
    }

    // Year of construction
    if (isEmpty(formData.year_of_construction)) {
      e.year_of_construction = "Year of construction is required.";
    } else {
      const yr = Number(formData.year_of_construction);
      if (!Number.isInteger(yr) || yr < 1900 || yr > thisYear) {
        e.year_of_construction = `Enter a valid year between 1900 and ${thisYear}.`;
      }
    }

    // Accessibility
    if (isEmpty(formData.accessibility)) {
      e.accessibility = "Accessibility is required.";
    } else if (!isNonNegInt(formData.accessibility)) {
      e.accessibility = "Enter a whole number 0 or greater.";
    }

    // Cultural & gender
    if (isEmpty(formData.cultural_gender)) {
      e.cultural_gender = "Cultural and gender appropriateness is required.";
    }

    // Pit latrines emptied (options list)
    if (isEmpty(formData.has_pit_latrines)) {
      e.has_pit_latrines =
        "Please select whether pit latrines have been emptied.";
    }

    // Last time emptied (who)
    if (isEmpty(formData.last_time_emptied)) {
      e.last_time_emptied = "Please select who emptied last time.";
    }

    // Conditional validations for last time emptied
    if (formData.last_time_emptied === "Others") {
      if (isEmpty(formData.last_time_emptied_other)) {
        e.last_time_emptied_other = "Please specify who emptied last time.";
      } else if (String(formData.last_time_emptied_other).trim().length < 3) {
        e.last_time_emptied_other = "Please enter at least 3 characters.";
      }
    }

    // Household disposal validation
    if (formData.last_time_emptied === "Emptied by the household") {
      if (isEmpty(formData.where_was_it_disposed)) {
        e.where_was_it_disposed = "Please specify where it was disposed.";
      }
    }

    // Removed by service provider (Yes/No)
    if (isEmpty(formData.removed_by_service_provider)) {
      e.removed_by_service_provider =
        "Please select if it was removed by service provider.";
    }

    // Service provider disposal validation
    if (
      formData.removed_by_service_provider === "Removed by a service provider"
    ) {
      if (isEmpty(formData.where_was_it_taken)) {
        e.where_was_it_taken = "Please specify where it was taken.";
      }
    }

    // Service provider other specification
    if (formData.removed_by_service_provider === "Others") {
      if (isEmpty(formData.removed_by_service_provider_other)) {
        e.removed_by_service_provider_other =
          "Please specify the service provider details.";
      } else if (
        String(formData.removed_by_service_provider_other).trim().length < 3
      ) {
        e.removed_by_service_provider_other =
          "Please enter at least 3 characters.";
      }
    }

    // Emptied by household (Yes/No)
    if (isEmpty(formData.emptied_by_household)) {
      e.emptied_by_household = "Please select if it was emptied by household.";
    }

    // Affected by floods
    if (isEmpty(formData.affected_by_floods)) {
      e.affected_by_floods = "Please select flood impact status.";
    }

    // Functional handwashing
    if (isEmpty(formData.functional_handwashing)) {
      e.functional_handwashing =
        "Please select if functional handwashing facility is available.";
    }

    // Soap/detergent available
    if (isEmpty(formData.soap_detergent_available)) {
      e.soap_detergent_available =
        "Please select if soap/detergent is available.";
    }

    // Hygiene promotion
    if (isEmpty(formData.hygiene_promotion)) {
      e.hygiene_promotion = "Please select hygiene promotion status.";
    }

    // Hygiene promotion specify (conditional)
    const needsSpecify =
      formData.hygiene_promotion ===
        "Yes, it was carried out for different groups (adults, men/women/children) in the past" ||
      formData.hygiene_promotion === "Other (specify)";
    if (needsSpecify) {
      if (isEmpty(formData.hygiene_promotion_specify)) {
        e.hygiene_promotion_specify =
          "Please provide hygiene promotion details.";
      } else if (String(formData.hygiene_promotion_specify).trim().length < 3) {
        e.hygiene_promotion_specify = "Please enter at least 3 characters.";
      }
    }

    // Hygiene promotion other
    if (isEmpty(formData.hygiene_promotion_other)) {
      e.hygiene_promotion_other =
        "Hygiene promotion other information is required.";
    }

    // Disposal of latrine waste
    if (isEmpty(formData.disposal_of_latrine_waste)) {
      e.disposal_of_latrine_waste = "Disposal of latrine waste is required.";
    }

    // Septic tanks
    if (isEmpty(formData.septic_tanks)) {
      e.septic_tanks = "Please select if septic tanks are present.";
    }

    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const handleUpdate = async () => {
    // Run form validation
    if (!validate()) {
      return;
    }

    try {
      setUpdating(true);
      const washInfoId = getCurrentWashInfoId();

      const updateData = {
        ...formData,
        wash_information_id: washInfoId,
        last_time_emptied: formData.last_time_emptied,
        last_time_emptied_other: formData.last_time_emptied_other,
        where_was_it_disposed: formData.where_was_it_disposed,
        where_was_it_taken: formData.where_was_it_taken,
        removed_by_service_provider: formData.removed_by_service_provider,
        removed_by_service_provider_other:
          formData.removed_by_service_provider_other,
      };

      delete updateData.emptied_by_household_disposal;
      delete updateData.removed_by_service_provider_disposal;

      const endpoint = washSanitationId
        ? `wash-sanitation/${washSanitationId}`
        : `wash-sanitation/wash-info/${washInfoId}`;

      const response = await fetchData(
        endpoint,
        "PUT",
        updateData,
        {},
        {},
        navigate,
        "/wash",
        dispatch
      );

      if (response?.success) {
        toast.success("Wash sanitation information updated successfully");
        onUpdate?.(response.data);
        await fetchWashSanitationData();
      } else {
        throw new Error(
          response?.message || "Failed to update wash sanitation information"
        );
      }
    } catch (error) {
      console.error("Error updating wash sanitation:", error);
      toast.error(
        error.message || "Error updating wash sanitation information"
      );
    } finally {
      setUpdating(false);
    }
  };

  const handleApprove = async () => {
    if (!validate()) {
      return;
    }

    try {
      setUpdating(true);
      const washInfoId = getCurrentWashInfoId();

      const approveResponse = await fetchData(
        `wash-information-approve/${washInfoId}`,
        "PUT",
        {},
        {},
        {},
        navigate,
        "/wash",
        dispatch
      );

      if (approveResponse?.success) {
        const approveData = {
          ...formData,
          wash_information_id: washInfoId,
          status: 1,
          // Store as plain strings - each field separately
          last_time_emptied: formData.last_time_emptied,
          last_time_emptied_other: formData.last_time_emptied_other,
          where_was_it_disposed: formData.where_was_it_disposed,
          where_was_it_taken: formData.where_was_it_taken,
          removed_by_service_provider: formData.removed_by_service_provider,
          removed_by_service_provider_other:
            formData.removed_by_service_provider_other,
        };

        delete approveData.emptied_by_household_disposal;
        delete approveData.removed_by_service_provider_disposal;

        const endpoint = washSanitationId
          ? `wash-sanitation/${washSanitationId}`
          : `wash-sanitation/wash-info/${washInfoId}`;

        const response = await fetchData(
          endpoint,
          "PUT",
          approveData,
          {},
          {},
          navigate,
          "/wash",
          dispatch
        );

        if (response?.success) {
          toast.success("Wash information approved from DQA successfully");
          setIsDqaApproved(true);
          onUpdate?.({ ...response.data, isDqaApproved: true });
          await fetchWashSanitationData();
        } else {
          throw new Error(
            response?.message || "Failed to update wash sanitation information"
          );
        }
      } else {
        throw new Error(
          approveResponse?.message || "Failed to approve wash information"
        );
      }
    } catch (error) {
      console.error("Error approving wash sanitation:", error);
      toast.error(
        error.message || "Error approving wash sanitation information"
      );
    } finally {
      setUpdating(false);
    }
  };

  const toiletTypes = [
    { label: "Flush/pour-flush", value: "Flush/pour-flush" },
    { label: "Dry pit latrine", value: "Dry pit latrine" },
    { label: "Bucket", value: "Bucket" },
    {
      label: "Hanging toilet/hanging latrine",
      value: "Hanging toilet/hanging latrine",
    },
  ];

  const statusOptions = [
    { label: "Fully functional", value: "Fully functional" },
    { label: "Partly functional", value: "Partly functional" },
    { label: "Non-functional", value: "Non-functional" },
  ];

  const ownershipOptions = [
    { label: "Communal", value: "Communal" },
    { label: "Private", value: "Private" },
  ];

  const hasPitLatrineOptions = [
    {
      label: "Yes, every time it is needed",
      value: "Yes, every time it is needed",
    },
    {
      label: "Yes, but not always on time",
      value: "Yes, but not always on time",
    },
    { label: "Never emptied", value: "Never emptied" },
  ];

  const lastTimeEmptiedOptions = [
    { label: "Emptied by the household", value: "Emptied by the household" },
    { label: "Other (Specify)", value: "Others" },
    { label: "Don't know", value: "Don't know" },
  ];

  const householdDisposalOptions = [
    { label: "Buried in a coveted pit", value: "Buried in a coveted pit" },
    {
      label: "To an uncovered pit, open ground, water body or elsewhere",
      value: "To an uncovered pit, open ground, water body or elsewhere",
    },
  ];

  const septicTanksOptions = [
    { label: "Availability", value: "availability" },
    { label: "Design", value: "design" },
    { label: "Functionality", value: "functionality" },
    { label: "Cleaning", value: "cleaning" },
    { label: "N/A", value: "N/A" },
  ];

  const serviceProviderOptions = [
    {
      label: "Removed by a service provider",
      value: "Removed by a service provider",
    },
    { label: "Other (Specify)", value: "Others" },
    { label: "Don't know", value: "Don't know" },
  ];

  const serviceProviderDisposalOptions = [
    { label: "To a treatment plant", value: "To a treatment plant" },
    { label: "Buried in a coveted pit", value: "Buried in a coveted pit" },
  ];

  const affectedFloodsOptions = [
    { label: "Yes, with no damages", value: "Yes, with no damages" },
    {
      label: "Yes, with damages not compromising its functionality",
      value: "Yes, with damages not compromising its functionality",
    },
    {
      label:
        "Yes, with damages affecting its functionality but it was repaired",
      value:
        "Yes, with damages affecting its functionality but it was repaired",
    },
    {
      label:
        "Yes, with damages affecting its functionality and it was not repaired",
      value:
        "Yes, with damages affecting its functionality and it was not repaired",
    },
    { label: "No", value: "No" },
    {
      label:
        "No, because it was made after the flood, but it is not clear if it is flood resilient",
      value:
        "No, because it was made after the flood, but it is not clear if it is flood resilient",
    },
    {
      label:
        "No, because it was made after the flood, and it is flood resilient",
      value:
        "No, because it was made after the flood, and it is flood resilient",
    },
  ];

  const hygienePromotionOptions = [
    {
      label: "Yes, most of the children do it at school",
      value: "Yes, most of the children do it at school",
    },
    {
      label:
        "Yes, it was carried out for different groups(adults, men/women/children) in the past",
      value:
        "Yes, it was carried out for different groups(adults, men/women/children) in the past",
    },
    { label: "No", value: "No" },
    { label: "Others", value: "Others" },
  ];

  // inline error renderer
  const Err = (name) =>
    errors?.[name] ? (
      <p className="text-red-600 text-sm mt-1">{errors[name]}</p>
    ) : null;

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="text-lg text-gray-600">
          Loading wash sanitation data...
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-teal-700 text-xl font-semibold">Wash Sanitation</h2>
        {isDqaApproved && (
          <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm font-semibold">
            Approved from DQA
          </span>
        )}
        {isDqaRejected && (
          <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm font-semibold">
            Rejected from DQA
          </span>
        )}
      </div>

      <form className="w-full">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div>
            <ThinTextField
              label="Latitude"
              type="number"
              value={formData.latitude}
              onChange={(e) => handleFieldChange("latitude", e.target.value)}
              disabled
            />
            {Err("latitude")}
          </div>
          <div>
            <ThinTextField
              label="Longitude"
              type="number"
              value={formData.longitude}
              onChange={(e) => handleFieldChange("longitude", e.target.value)}
              disabled
            />
            {Err("longitude")}
          </div>

          <div>
            <ThinTextField disabled={isDqaApproved || isDqaRejected}
              label="Number of Households Served"
              type="number"
              value={formData.number_of_household_served}
              onChange={(e) => {
                const val = e.target.value;

                if (
                  val === "" ||
                  (/^\d{0,5}$/.test(val) && Number(val) <= 32767)
                ) {
                  handleFieldChange("number_of_household_served", val);
                }
              }}
            />
            {Err("number_of_household_served")}
          </div>

          <div>
            <ThinDropdownWithSearch disabled={isDqaApproved || isDqaRejected}
              label="Type of Toilet"
              id="toilet-type"
              options={toiletTypes}
              value={formData.type_of_toilet}
              onChange={(value) => handleFieldChange("type_of_toilet", value)}
            />
            {Err("type_of_toilet")}
          </div>

          <div>
            <ThinDropdownWithSearch disabled={isDqaApproved || isDqaRejected}
              label="Status of Toilet"
              id="toilet-status"
              options={statusOptions}
              value={formData.status_of_toilet}
              onChange={(value) => handleFieldChange("status_of_toilet", value)}
            />
            {Err("status_of_toilet")}
          </div>

          {formData.status_of_toilet === "Non-functional" && (
            <div>
              <ThinTextField disabled={isDqaApproved || isDqaRejected}
                label="Non-functional since (days)"
                type="number"
                value={formData.non_functional_since}
                onChange={(e) =>
                  handleFieldChange("non_functional_since", e.target.value)
                }
              />
              {Err("non_functional_since")}
            </div>
          )}

          <div>
            <ThinDropdownWithSearch disabled={isDqaApproved || isDqaRejected}
              label="Ownership"
              id="ownership"
              options={ownershipOptions}
              value={formData.ownership}
              onChange={(value) => handleFieldChange("ownership", value)}
            />
            {Err("ownership")}
          </div>

          <div>
            <ThinTextField disabled={isDqaApproved || isDqaRejected}
              label="Year of Construction"
              type="number"
              value={formData.year_of_construction}
              onChange={(e) =>
                handleFieldChange("year_of_construction", e.target.value)
              }
            />
            {Err("year_of_construction")}
          </div>

          <div>
            <ThinTextField disabled={isDqaApproved || isDqaRejected}
              label="Accessibility"
              type="number"
              value={formData.accessibility}
              onChange={(e) =>
                handleFieldChange("accessibility", e.target.value)
              }
            />
            {Err("accessibility")}
          </div>

          <div className="mt-6">
            <p className="mb-2 text-sm font-medium text-gray-700">
              Cultural and gender appropriateness
            </p>
            <div className="flex items-center gap-4">
              <label className="flex items-center gap-1">
                <input disabled={isDqaApproved || isDqaRejected}
                  type="radio"
                  name={`cultural_gender_${currentWashInfoId || "default"}`}
                  value="Yes"
                  checked={formData.cultural_gender === "Yes"}
                  onChange={(e) =>
                    handleFieldChange("cultural_gender", e.target.value)
                  }
                  className="accent-blue-600"
                />
                <span className="text-sm text-gray-700">Yes</span>
              </label>
              <label className="flex items-center gap-1">
                <input disabled={isDqaApproved || isDqaRejected}
                  type="radio"
                  name={`cultural_gender_${currentWashInfoId || "default"}`}
                  value="No"
                  checked={formData.cultural_gender === "No"}
                  onChange={(e) =>
                    handleFieldChange("cultural_gender", e.target.value)
                  }
                  className="accent-blue-600"
                />
                <span className="text-sm text-gray-700">No</span>
              </label>
            </div>
            {Err("cultural_gender")}
          </div>

          <div>
            <ThinDropdownWithSearch disabled={isDqaApproved || isDqaRejected}
              label="Has pit latrines or septic tanks ever been emptied?"
              id="has-pit-latrines"
              options={hasPitLatrineOptions}
              value={formData.has_pit_latrines}
              onChange={(value) => handleFieldChange("has_pit_latrines", value)}
            />
            {Err("has_pit_latrines")}
          </div>

          <div>
            <ThinDropdownWithSearch disabled={isDqaApproved || isDqaRejected}
              label="When last time they were emptied?"
              id="last-time-emptied"
              options={lastTimeEmptiedOptions}
              value={formData.last_time_emptied}
              onChange={(value) =>
                handleFieldChange("last_time_emptied", value)
              }
            />
            {Err("last_time_emptied")}
          </div>

          {formData.last_time_emptied === "Others" && (
            <div>
              <ThinTextField disabled={isDqaApproved || isDqaRejected}
                label="Please specify last time emptied?"
                value={formData.last_time_emptied_other}
                onChange={(e) =>
                  handleFieldChange("last_time_emptied_other", e.target.value)
                }
              />
              {Err("last_time_emptied_other")}
            </div>
          )}

          {formData.last_time_emptied === "Emptied by the household" && (
            <div>
              <ThinDropdownWithSearch disabled={isDqaApproved || isDqaRejected}
                label="Where was it disposed?"
                id="household-disposal"
                options={householdDisposalOptions}
                value={formData.where_was_it_disposed}
                onChange={(value) =>
                  handleFieldChange("where_was_it_disposed", value)
                }
              />
              {Err("where_was_it_disposed")}
            </div>
          )}

          <div>
            <ThinDropdownWithSearch disabled={isDqaApproved || isDqaRejected}
              label="Was it removed by a service provider?"
              id="service-provider"
              options={serviceProviderOptions}
              value={formData.removed_by_service_provider}
              onChange={(value) =>
                handleFieldChange("removed_by_service_provider", value)
              }
            />
            {Err("removed_by_service_provider")}
          </div>

          {formData.removed_by_service_provider ===
            "Removed by a service provider" && (
            <div>
              <ThinDropdownWithSearch disabled={isDqaApproved || isDqaRejected}
                label="Where was it taken?"
                id="service-provider-disposal"
                options={serviceProviderDisposalOptions}
                value={formData.where_was_it_taken}
                onChange={(value) =>
                  handleFieldChange("where_was_it_taken", value)
                }
              />
              {Err("removed_by_service_provider_disposal")}
            </div>
          )}

          {formData.removed_by_service_provider === "Others" && (
            <div>
              <ThinTextField disabled={isDqaApproved || isDqaRejected}
                label="Please specify service provider"
                value={formData.removed_by_service_provider_other}
                onChange={(e) =>
                  handleFieldChange(
                    "removed_by_service_provider_other",
                    e.target.value
                  )
                }
              />
              {Err("removed_by_service_provider_other")}
            </div>
          )}

          <div>
            <ThinDropdownWithSearch disabled={isDqaApproved || isDqaRejected}
              label="The toilet facility was affected by the floods?"
              id="affected-by-floods"
              options={affectedFloodsOptions}
              value={formData.affected_by_floods}
              onChange={(value) =>
                handleFieldChange("affected_by_floods", value)
              }
            />
            {Err("affected_by_floods")}
          </div>

          <div className="mt-6">
            <p className="mb-2 text-sm font-medium text-gray-700">
              Functional handwashing facility (a sink and/or a tap, or even
              bucket) is accessible and not far away
            </p>
            <div className="flex items-center gap-4">
              <label className="flex items-center gap-1">
                <input disabled={isDqaApproved || isDqaRejected}
                  type="radio"
                  name={`functional_handwashing_${
                    currentWashInfoId || "default"
                  }`}
                  value="Yes"
                  checked={formData.functional_handwashing === "Yes"}
                  onChange={(e) =>
                    handleFieldChange("functional_handwashing", e.target.value)
                  }
                  className="accent-blue-600"
                />
                <span className="text-sm text-gray-700">Yes</span>
              </label>
              <label className="flex items-center gap-1">
                <input disabled={isDqaApproved || isDqaRejected}
                  type="radio"
                  name={`functional_handwashing_${
                    currentWashInfoId || "default"
                  }`}
                  value="No"
                  checked={formData.functional_handwashing === "No"}
                  onChange={(e) =>
                    handleFieldChange("functional_handwashing", e.target.value)
                  }
                  className="accent-blue-600"
                />
                <span className="text-sm text-gray-700">No</span>
              </label>
            </div>
            {Err("functional_handwashing")}
          </div>

          <div className="mt-6">
            <p className="mb-2 text-sm font-medium text-gray-700">
              Is soap/detergent available for this handwashing facility?
            </p>
            <div className="flex items-center gap-4">
              <label className="flex items-center gap-1">
                <input disabled={isDqaApproved || isDqaRejected}
                  type="radio"
                  name={`soap_detergent_available_${
                    currentWashInfoId || "default"
                  }`}
                  value="Yes"
                  checked={formData.soap_detergent_available === "Yes"}
                  onChange={(e) =>
                    handleFieldChange(
                      "soap_detergent_available",
                      e.target.value
                    )
                  }
                  className="accent-blue-600"
                />
                <span className="text-sm text-gray-700">Yes</span>
              </label>
              <label className="flex items-center gap-1">
                <input disabled={isDqaApproved || isDqaRejected}
                  type="radio"
                  name={`soap_detergent_available_${
                    currentWashInfoId || "default"
                  }`}
                  value="No"
                  checked={formData.soap_detergent_available === "No"}
                  onChange={(e) =>
                    handleFieldChange(
                      "soap_detergent_available",
                      e.target.value
                    )
                  }
                  className="accent-blue-600"
                />
                <span className="text-sm text-gray-700">No</span>
              </label>
            </div>
            {Err("soap_detergent_available")}
          </div>

          <div>
            <ThinDropdownWithSearch disabled={isDqaApproved || isDqaRejected}
              label="Hygiene Promotion?"
              id="hygiene-promotion"
              options={hygienePromotionOptions}
              value={formData.hygiene_promotion}
              onChange={(value) =>
                handleFieldChange("hygiene_promotion", value)
              }
            />
            {Err("hygiene_promotion")}
          </div>

          {(formData.hygiene_promotion ===
            "Yes, it was carried out for different groups (adults, men/women/children) in the past" ||
            formData.hygiene_promotion === "Other (specify)") && (
            <div>
              <ThinTextField disabled={isDqaApproved || isDqaRejected}
                label="Hygiene Promotion Specify"
                value={formData.hygiene_promotion_specify}
                onChange={(e) =>
                  handleFieldChange("hygiene_promotion_specify", e.target.value)
                }
              />
              {Err("hygiene_promotion_specify")}
            </div>
          )}

          <div>
            <ThinTextField disabled={isDqaApproved || isDqaRejected}
              label="Hygiene Promotion Other"
              value={formData.hygiene_promotion_other}
              onChange={(e) =>
                handleFieldChange("hygiene_promotion_other", e.target.value)
              }
            />
            {Err("hygiene_promotion_other")}
          </div>

          <div>
            <ThinTextField disabled={isDqaApproved || isDqaRejected}
              label="Disposal of Latrine Waste"
              value={formData.disposal_of_latrine_waste}
              onChange={(e) =>
                handleFieldChange("disposal_of_latrine_waste", e.target.value)
              }
            />
            {Err("disposal_of_latrine_waste")}
          </div>

          <div className="mt-6">
            <p className="mb-2 text-sm font-medium text-gray-700">
              Septic Tanks
            </p>
            <div className="grid grid-cols-2 gap-2">
              {septicTanksOptions.map((option) => (
                <label key={option.value} className="flex items-center gap-2">
                  <input disabled={isDqaApproved || isDqaRejected}
                    type="radio"
                    name="septic_tanks"
                    value={option.value}
                    checked={formData.septic_tanks === option.value}
                    onChange={(e) =>
                      handleFieldChange("septic_tanks", e.target.value)
                    }
                    className="accent-blue-600"
                  />
                  <span className="text-sm text-gray-700">{option.label}</span>
                </label>
              ))}
            </div>

            {Err("septic_tanks")}
          </div>
        </div>

        {!isDqaApproved && !isDqaRejected && (
          <div className="mt-8 flex justify-end gap-4">
            <button
              type="button"
              onClick={handleUpdate}
              disabled={updating}
              className={`${
                updating ? "bg-gray-400" : "bg-teal-600 hover:bg-teal-700"
              } text-white px-4 py-2 rounded-lg transition duration-200 font-medium`}
            >
              {updating ? "Updating..." : "Update"}
            </button>
            <button
              type="button"
              onClick={handleApprove}
              disabled={updating}
              className={`${
                updating ? "bg-gray-400" : "bg-[#caa316] hover:bg-[#b8920c]"
              } text-white px-4 py-2 rounded-lg transition duration-200 font-medium`}
            >
              {updating ? "Approving..." : "Approve"}
            </button>
          </div>
        )}
      </form>
    </>
  );
};

export default WashSanitation;
